.root,
.root-is-completed {
  align-items: center;
  background: var(--color-secondary, #f3f4f6);
  border: none;
  border-radius: 8px;
  color: var(--color-muted, #6b7280);
  cursor: pointer;
  display: inline-flex;
  height: 28px;
  justify-content: center;
  padding: 0;
  transition: background 0.15s, color 0.15s;
  width: 28px;
}

.root:hover:not(:disabled) {
  background: rgba(16, 185, 129, 0.15);
  color: var(--color-success, #10b981);
}

.root-is-completed {
  background: var(--color-success, #10b981);
  color: var(--color-on-success, #ffffff);
}

.root-is-completed:hover:not(:disabled) {
  background: var(--color-success-hover, #059669);
}

.root:disabled,
.root-is-completed:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}
